var React = require('react');

function Pl (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},[React.createElement("path",{"fill":"#fff","d":"M640 480H0V0h640z","key":0}),React.createElement("path",{"fill":"#dc143c","d":"M640 480H0V240h640z","key":1})]));
}

Pl.defaultProps = {"id":"flag-icons-pl","viewBox":"0 0 640 480"};

module.exports = Pl;

Pl.default = Pl;
